import { API } from "./API";
import { DesignerController } from "./DesignerController";
import { DesignerText, DesignerDate, DesignerImage, DesignerRect, DesignerQRCode } from "./DesignerElements";
import { PopupToggle } from "./DesignerPopup";
import { ActiveTabs, Alignment, Clipart, ColorObject, Config, RenderMode, Tabs, TextSpecials, VKData } from "./TypescriptInterfaces";
import { Utility } from "./Utility";
import Choices from "Choices";
//import Sortable from "./external/Sortable";
//import Sortable from 'sortablejs';
// @ts-expect-error No declaration file for sortablejs modular ESM path
import Sortable from "sortablejs/modular/sortable.core.esm.js";

//Loading and processing the tabs on the left side
class TabInterface{
    controller: DesignerController;
    config: Config;
    API: API;
    tabsHTML: Tabs|null = null;
    activeTab: ActiveTabs = "text";
    inputFocused: boolean = false;

    constructor(controller: DesignerController, config:Config, API:API){
        this.controller = controller;
        this.config = config
        this.API = API;
    }

    generateMCIButton(color: string | null): HTMLButtonElement{
        let menuButtonMCI = document.createElement('button');
        menuButtonMCI.classList.add("menu_button", "mci_toggle_button");
        menuButtonMCI.title = "MCI Farbe auswählen";
        let menuIcon = document.createElement('img');
        menuIcon.src = this.controller.config.imagePath+'colors_fill_small.svg';
        if(menuIcon && color){
            menuIcon.style.borderColor = color;
        }
        menuButtonMCI.appendChild(menuIcon);
        return menuButtonMCI;
    }

    //List patterns for this article
    renderPatternTab(){
        if(this.tabsHTML == null){
            return false;
        }

        let artikel_nr = this.config.dataset.artikel;

        document.getElementById('config_tabs')!.innerHTML = this.tabsHTML.pattern;

        //NEW
        //let categorySelect = document.getElementById('pattern_select') as HTMLSelectElement;
        let patternArea = document.getElementById('pattern_area') as HTMLDivElement;

        let button_pattern_design = document.getElementById('pattern_select_design') as HTMLButtonElement;
        let button_pattern_text = document.getElementById('pattern_select_text') as HTMLButtonElement;


        button_pattern_text.addEventListener('click', () => {
            //Clear pattern area
            patternArea.innerHTML = "";
            button_pattern_text.classList.add("active");
            if(button_pattern_design) {
                button_pattern_design.classList.remove("active");
            }
            this.loadPatternsToArea(artikel_nr, patternArea, "text");
        });
        

        //Initial loading
        patternArea.innerHTML = "";

        if(this.controller.config.init.designPattern == false){
            patternArea.innerHTML = "";
            button_pattern_text.classList.add("active");
            button_pattern_design.remove();
            this.loadPatternsToArea(artikel_nr, patternArea, "text");
        }else{

            button_pattern_design.addEventListener('click', () => {
                //Clear pattern area
                patternArea.innerHTML = "";
                button_pattern_design.classList.add("active");
                button_pattern_text.classList.remove("active");
                this.loadPatternsToArea(artikel_nr, patternArea, "design_and_global");
            });

            //Check if global patterns
            //Porduct specfic patterns
            let patternPromises = [];

            patternPromises.push( this.API.requestDesignPatterns(this.config.dataset.artikel) );
            patternPromises.push( this.API.requestGlobalPatterns(this.config.dataset.artikel) );

            Promise.allSettled(patternPromises).then(
                (results) => {
                    // First is product specific patterns, second is global patterns
                    //If global patterns are available, remove specific patterns
                    if( results[1].status == "fulfilled" && results[1].value[1] ){
                        // Remove product specific patterns
                        console.log("Entferne produkt spezifische Muster, globale vorhanden");
                        this.loadPatternsToArea(artikel_nr, patternArea, "global");
                    }else{
                        console.log("Zeige alle Muster");
                        this.loadPatternsToArea(artikel_nr, patternArea, "design_and_global");
                    }
                }
            );
        }

        
        
    }

    loadPatternsToArea(artikel_nr: string, patternArea: HTMLDivElement, category: string){
        //Clear pattern area
        patternArea.innerHTML = "";

        switch(category){
            case "text":
                this.loadTextPatternsToArea(artikel_nr, patternArea);
                break;
            case "global":
                this.loadGlobalPatternsToArea(artikel_nr, patternArea);
                break;
            case "design_and_global":
                this.loadDesignPatternsToArea(artikel_nr, patternArea);
                this.loadGlobalPatternsToArea(artikel_nr, patternArea);
                break;
        }
    }

    loadTextPatternsToArea(artikel_nr: string, patternArea: HTMLDivElement){
        this.API.requestTextPatterns(artikel_nr).then(
            (data:any) => {
                for(let key in data){
                    let pattern = data[key]; 
                    let patternDiv = this.generatePatternItem(pattern, "text", key);
                    patternArea?.appendChild(patternDiv);
                }
            }
        );
    }

    loadDesignPatternsToArea(artikel_nr: string, patternArea: HTMLDivElement){
        this.API.requestDesignPatterns(artikel_nr).then(
            (data:any) => {
                for(let key in data){
                    let pattern = data[key]; 
                    let patternDiv = this.generatePatternItem(pattern, "design", key);
                    patternArea?.appendChild(patternDiv);
                }
            }
        );
    }

    loadGlobalPatternsToArea(artikel_nr: string, patternArea: HTMLDivElement){
        this.API.requestGlobalPatterns(artikel_nr).then(
            (data:any) => {
                for(let key in data){
                    let pattern = data[key]; 
                    let patternDiv = this.generatePatternItem(pattern, "global", key);
                    patternArea?.appendChild(patternDiv);
                }
            }
        );
    }

    //Generate pattern item
    generatePatternItem(pattern: any, type: string, id: string){
        let patternDiv = document.createElement('div');
        let patternDivTitle = document.createElement('div');
        let patternDivImageBox = document.createElement('div');
        patternDiv.classList.add("pattern_box");
        patternDiv.dataset.patternName = pattern.name;
        patternDiv.dataset.patternID = id;

        let _this = this;
        patternDiv.addEventListener("click", function(e){
            let patternID = this.dataset.patternID;
            if(!patternID){
                console.error("Pattern has no ID! Can't load.");
                return;
            }
            let id = Number.parseInt(patternID);
            switch(type){
                case "text":
                    //When there's content, just apply the pattern settings
                    if(_this.controller.elements.length > 0){
                        _this.controller.patternController.loadTextPattern(id, false, false, false);
                    }else{
                        //When there's nothing, load entire pattern
                        _this.controller.patternController.loadTextPattern(id, true, false, true);
                    }
                    break;
                case "design":
                    _this.controller.patternController.loadDesignPattern(id, _this.config.dataset.artikel);
                    break;
                case "global":
                    _this.controller.patternController.loadGlobalPattern(id, _this.config.dataset.artikel);
            }
        });
        //patternDivTitle.innerText = "Muster "+pattern.name;
        

        patternDivImageBox.classList.add("pattern_box_image");

        let img = document.createElement('div');
        img.style.backgroundImage = "url("+pattern.jpg+")";
        

        patternDivImageBox.appendChild(img);

        patternDiv.appendChild(patternDivTitle);
        patternDiv.appendChild(patternDivImageBox);
        return patternDiv;
    }

    //List users saved patterns
    renderUserPatternTab(){
        if(this.tabsHTML == null){
            return false;
        }
        document.getElementById('config_tabs')!.innerHTML = this.tabsHTML.userpattern;

        if(this.controller.config.userPattern.create == false){
            document.getElementById('userpattern_create')?.remove();
        }

        let codeLoad = document.getElementById('userpattern_code') as HTMLInputElement;
        codeLoad.value = this.config.userCode;

        let codeLoadButton = document.getElementById('userpattern_load_button') as HTMLButtonElement;

        let codeSaveButton = document.getElementById('userpattern_create_button') as HTMLButtonElement;
        let codeSaveName = document.getElementById('userpattern_create_name') as HTMLButtonElement;
        

        this.renderUserPatterns(this.config.dataset.artikel, this.config.userCode);

        //EVENT LISTENER
        let _this = this;
        if(codeLoadButton){
            codeLoadButton.addEventListener('click', function (evt) {
                //Overwrite local code with last used one
                let code = codeLoad.value.trim();
                if(code.length > 0){
                    localStorage.setItem("designer2021_userCode", code);
                    _this.renderUserPatterns(_this.config.dataset.artikel, code, false);
                }
            });
        }

        if(codeSaveButton){
            codeSaveButton.addEventListener('click', function (evt) {
                let name = codeSaveName.value;
                let code = _this.config.userCode;
                let saved = _this.saveUserPattern(code, name);
                if(saved){
                    codeSaveName.value = "";
                }
            });
        }
    }
    
    //List text items for easy editing
    renderTextTab(){
        if(this.activeTab !== "text"){
            return false;
        }
        if(this.tabsHTML == null){
            return false;
        }
        document.getElementById('config_tabs')!.innerHTML = this.tabsHTML.text;
        let listDIV = document.getElementById('item_list')!;
        let i = 1;
        let rowCount = 0;
        for(let el of this.controller.elements){
            if(el instanceof DesignerText){
                if(el.blockedActions.includes("list") && !this.controller.adminMode){
                    continue;
                }
                rowCount ++;
                let element = el;
                //Build list
                let row = document.createElement('div');
                row.dataset.id = element.id.toString();

                //let wrapGroup1 = document.createElement('div');
    
                let number = document.createElement('span');
                number.innerHTML = i.toString();
    
                let text = document.createElement('input');
                text.classList.add('text_input');
                text.value = element.text;

                //Select options for autocomplete
                let datalist = this.renderTextOptionsDatalist(element);
                text.setAttribute('list', datalist.id);
                row.appendChild(datalist);
                
                this.renderTextOptionsDropdown(element, text);

                //TEXT DROPDOWN
                //In admin modus allow adding and removing select options
                //Add a small button after text to expand/collapse select options
                let expandButton = document.createElement('button');
                expandButton.classList.add("text_select_options_expand_button");
                expandButton.innerHTML = '<img src="'+this.controller.config.imagePath+'arrow_down_white_24dp.svg" class="icon_small invert">'; 

                let optionsDiv = document.createElement('div');
                optionsDiv.classList.add("text_select_options_div");
                optionsDiv.style.display = "none";
                let optionsList = this.renderTextOptionsList(element, datalist);
                optionsDiv.appendChild(optionsList);
                Sortable.create(optionsList, {
                    animation: 150,
                    onEnd: () => {
                        //Update element.selectOptions to match new order
                        let newOrder: string[] = [];
                        for(let child of optionsList.children){
                            let optionValue = (child as HTMLDivElement).dataset.optionValue;
                            if(optionValue){
                                newOrder.push(optionValue);
                            }
                        }
                        element.selectOptions = newOrder;
                        let newDatalist = this.renderTextOptionsDatalist(element);
                        datalist.innerHTML = newDatalist.innerHTML;

                        this.renderTextOptionsDropdown(element, text);
                    }
                });

                //Remove button
                let removeButtons = optionsList.querySelectorAll('.text_select_option_remove_button');
                for(let removeButton of removeButtons){
                    removeButton.addEventListener('click', (evt) => {
                        let option = (removeButton.parentElement as HTMLDivElement).dataset.optionValue;
                        if(!option){
                            return;
                        }
                        let index = element.selectOptions.indexOf(option);
                        if(index > -1){
                            element.selectOptions.splice(index, 1);

                            //Update options list in UI
                            let optionItem = removeButton.parentElement as HTMLDivElement;
                            optionsList.removeChild(optionItem);

                            //Update datalist for autocomplete
                            let datalistObject = datalist.querySelector('option[value="'+option+'"]');
                            if(!datalistObject){
                                console.error("Could not find datalist option to remove!");
                                return;
                            }
                            datalist.removeChild(datalistObject);

                            //Update datalist for autocomplete
                            let newDatalist = this.renderTextOptionsDatalist(element);
                            datalist.innerHTML = newDatalist.innerHTML;

                            this.renderTextOptionsDropdown(element, text);
                        }
                    });
                }

                //Adding new option
                let addOptionContainer = document.createElement('div');
                let addOptionInput = document.createElement('input');
                addOptionInput.classList.add("text_select_option_add_input");
                addOptionInput.placeholder = "Neue Option";

                let addOptionButton = document.createElement('button');
                addOptionButton.classList.add("text_select_option_add_button");
                addOptionButton.innerHTML = "Hinzufügen";
                
                addOptionContainer.appendChild(addOptionInput);
                addOptionContainer.appendChild(addOptionButton);

                optionsDiv.appendChild(addOptionContainer);

                addOptionButton.addEventListener('click', (evt) => {
                    let newOption = addOptionInput.value.trim();
                    if (newOption.length > 0 && !element.selectOptions.includes(newOption)) {
                        element.selectOptions.push(newOption);

                        //Update options list in UI
                        let newOptionsList = this.renderTextOptionsList(element, datalist);
                        optionsDiv.replaceChild(newOptionsList, optionsList);
                        optionsList = newOptionsList;
                        Sortable.create(optionsList, {
                            animation: 150
                        });
                        //Remove button
                        let removeButtons = optionsList.querySelectorAll('.text_select_option_remove_button');
                        for(let removeButton of removeButtons){
                            removeButton.addEventListener('click', (evt) => {
                                let option = (removeButton.parentElement as HTMLDivElement).dataset.optionValue;
                                if(!option){
                                    return;
                                }
                                let index = element.selectOptions.indexOf(option);
                                if(index > -1){
                                    element.selectOptions.splice(index, 1);

                                    //Update options list in UI
                                    let optionItem = removeButton.parentElement as HTMLDivElement;
                                    optionsList.removeChild(optionItem);

                                    //Update datalist for autocomplete
                                    let datalistObject = datalist.querySelector('option[value="'+option+'"]');
                                    if(!datalistObject){
                                        console.error("Could not find datalist option to remove!");
                                        return;
                                    }
                                    datalist.removeChild(datalistObject);

                                    //Update datalist for autocomplete
                                    let newDatalist = this.renderTextOptionsDatalist(element);
                                    datalist.innerHTML = newDatalist.innerHTML;

                                    this.renderTextOptionsDropdown(element, text);
                                }
                            });
                        }

                        //Update datalist for autocomplete
                        let newDatalist = this.renderTextOptionsDatalist(element);
                        datalist.innerHTML = newDatalist.innerHTML;

                       this.renderTextOptionsDropdown(element, text);
                        
                        addOptionInput.value = "";
                    }
                });

                expandButton.addEventListener('click', (evt) => {
                    if (optionsDiv.style.display === "none") {
                        optionsDiv.style.display = "flex";
                        expandButton.innerHTML = '<img src="'+this.controller.config.imagePath+'arrow_up_white_24dp.svg" class="icon_small invert">';
                    } else {
                        optionsDiv.style.display = "none";
                        expandButton.innerHTML = '<img src="'+this.controller.config.imagePath+'arrow_down_white_24dp.svg" class="icon_small invert">';
                    }
                });
                
                

                

                

                let stepSize = this.config.fontIncrement;
                let textsize = this.generateFontSizeDropdown(stepSize, element.size);
                
                
                //Generate text sizes
                
    
                //Generate Font Select from list
                
                let font = this.generateFontDropdown(element.font);
    
                let menuButton = document.createElement('button');
                menuButton.classList.add("menu_button");
                menuButton.title = "Weitere Einstellungen";
                let menuIcon = document.createElement('img');
                menuIcon.src = this.controller.config.imagePath+'tune_black_24dp.svg';
                menuButton.appendChild(menuIcon);

                //MCI Icon
                let menuButtonMCI = this.generateMCIButton(element.color);
    
                //EVENT LISTENERS
                let _this = this;
                text.addEventListener('input', function (evt) {
                    //update Text
                    let textValue = (evt.target as HTMLInputElement).value;
                    element.setText(textValue, false);
                });

                text.addEventListener('focus', () => {
                    this.inputFocused = true;
                });
                text.addEventListener('blur', () => {
                    this.inputFocused = false;
                });
    
                row.addEventListener('click', function (evt) {
                    _this.controller.input.elementSelected = element;
                });
    
                menuButton.addEventListener('click', function (evt) {
                    _this.controller.input.elementSelected = element;
                    let pos = Utility.relativePosition(_this.controller.canvas, document.body);
                    _this.controller.openElementToolsOnElement(element);
                    _this.highlightText(element.id);
                });

                menuButtonMCI.addEventListener('click',  (evt) => {
                    this.controller.input.elementSelected = element;
                    let pos = Utility.relativePosition(this.controller.canvas, document.body);
                    this.controller.openElementToolsOnElement(element);

                    let toggle = this.controller.activeElementTools?.findElement("mci_toggle_button") as PopupToggle;
                    toggle.toggleOn();
                    this.highlightText(element.id);
                });
    
                textsize.addEventListener('change', function (evt) {
                    //update Text
                    let size = parseFloat((evt.target as HTMLSelectElement).value);
                    element.setSize(size, true, true, true);
                });
    
                font.addEventListener('change', function (evt) {
                    //update Text
                    let font = (evt.target as HTMLSelectElement).value;
                    element.setFont(font);
                });
    
    
                row.appendChild(number);

                if(!el.blockedActions.includes("changeText") || this.controller.adminMode ){
                    
                    let container = document.createElement('div');
                    container.classList.add("text_input_container");
                    container.appendChild(text);
                    row.appendChild(container);

                    

                    if(this.controller.adminMode && this.controller.showTextDropdownButton){
                        row.appendChild(expandButton);
                    }
                }
                if( (this.config.init.text.changeSize == true && !el.blockedActions.includes("scale") ) || this.controller.adminMode ){
                    row.appendChild(textsize);
                }
                if( (this.config.init.text.changeFont == true && !el.blockedActions.includes("changeFont") ) || this.controller.adminMode ){
                    row.appendChild(font);
                    //Custom dropdown element (<select> isn't stylable in Firefox)
                    const choices = new (Choices as any)(font, {
                        allowHTML: true, 
                        itemSelectText: '',
                        shouldSort: false,
                        searchEnabled: false,
                    });

                    // Keep Choices dropdown fixed and position it via JS (desktop only)
                    const choicesContainer = font.closest('.choices') as HTMLDivElement | null;
                    const isDesktopView = () => window.matchMedia('(min-width: 901px)').matches;
                    const updateChoicesDropdownPosition = () => {
                        if(!isDesktopView()){
                            return;
                        }
                        if(!choicesContainer){
                            return;
                        }
                        const dropdown = choicesContainer.querySelector('.choices__list--dropdown') as HTMLDivElement | null;
                        if(!dropdown){
                            return;
                        }
                        const isFlipped = dropdown.classList.contains('is-flipped') || choicesContainer.classList.contains('is-flipped');
                        
                        const rect = choicesContainer.getBoundingClientRect();
                        dropdown.style.position = 'fixed';
                        dropdown.style.bottom = 'auto';
                        dropdown.style.left = rect.left + 'px';
                        dropdown.style.top = isFlipped
                            ? (rect.top - dropdown.offsetHeight) + 'px'
                            : rect.bottom + 'px';
                        dropdown.style.width = rect.width + 'px';
                        dropdown.style.zIndex = '9999';
                    };

                    if(isDesktopView()){
                        // Initial + open positioning
                        window.setTimeout(updateChoicesDropdownPosition, 0);
                        font.addEventListener('showDropdown', updateChoicesDropdownPosition as EventListener);
                        font.addEventListener('focus', updateChoicesDropdownPosition);
                        choicesContainer?.addEventListener('click', updateChoicesDropdownPosition);

                        // Reposition while scrolling/resizing
                        window.addEventListener('resize', updateChoicesDropdownPosition);
                        window.addEventListener('scroll', updateChoicesDropdownPosition, true);
                    }

                }

                if(this.controller.MCI ){
                    row.appendChild(menuButtonMCI);
                }

                row.appendChild(menuButton);


                

                //row.appendChild(wrapGroup0);
                //row.appendChild(wrapGroup1);
                listDIV.appendChild(row);
                if(this.controller.adminMode){
                    listDIV.appendChild(optionsDiv);
                }

                i++;
            }
        }
        //Utility buttons
        var addTextButton = document.getElementById('add_text_button')!;
        var removeTextButton = document.getElementById('remove_text_button')!;
    
        if(this.config.init.text.addRows == false){
            addTextButton.style.display = "none";
        }

        if(this.config.init.text.removeRows == false){
            removeTextButton.style.display = "none";
        }
    
        let _this = this;
        addTextButton.addEventListener('click', () => {
            /*
            if(_this.controller.textMaximum()){
                window.alert("Bereits maximale Zeilenanzahl für den Stempel erreicht: "+_this.config.init.text.maxRows)
                return;
            }
            */

            //get bottom X and Y
            let center = _this.controller.editAreaCenter();
            let x = center.x;
            let y = center.y;
            let h = 0;
            let lastText = _this.controller.getLastText();

            //Copy last text elements settings if possible
            if(lastText){
                
                y = lastText.y;
                x = lastText.x;
                
                h = lastText.h;
            }

            
            let size = this.config.maxHeightMM / 6;
            size = Utility.clamp(size, this.config.fontMinSize, this.config.fontMaxSize);
            size = Math.floor(size);
            //Use Roboto if available
            let font = _this.controller.fonts[0].name;
            if( this.controller.fontIsLoaded("Roboto") ){
                font = "Roboto";
            }

            let align:Alignment = null;

            let lastW = 0;
            if(lastText){
                size = lastText.size;
                font = lastText.font;
                align = lastText.align;
                lastW = lastText.getDimensions().w;
            }

            let area = _this.controller.editAreaSize();

            let yNew = y+(h+_this.config.pixelToMM);

            //If round, place in center
            if(this.controller.round){
                yNew = center.y + (this.controller.elements.length * this.controller.config.pixelToMM);
            }

            //Limit to bottom of area
            yNew = Math.min(area.maxY-h, yNew);

            let text = new DesignerText(_this.controller, x, yNew, "Text eingeben", size, font, align);

            if(lastText){
                text.setBold(lastText.bold);
                text.setItalic(lastText.italic);
                text.setUnderline(lastText.underline);
                text.setAlignment(lastText.align);
            }

            //Set color to pad color
            text.setColor(_this.controller.inkpadColor);

            let w = text.getDimensions().w;
            //Center under last text
            if(lastText && (text.align == "centerH" || text.align == null)){
                text.x += (lastW - w)/2;
            }

            text.addElement(true,true,true,true);
            text.moveRelative(0, 0, false, false, false);
            _this.controller.input.elementSelected = text;
        });
    
        removeTextButton.addEventListener('click', function (evt) {
            if(_this.controller.textMinimum()){
                window.alert("Bereits minimale Zeilenanzahl für den Stempel erreicht: "+_this.config.init.text.minRows)
                return;
            }
            let last;
            for(let element of _this.controller.elements){
                if(element instanceof DesignerText && !(element instanceof DesignerDate)){
                    last = element;
                }
            }
            if(last){
                _this.controller.deleteElement(last);
            }
            
        });

        this.addApplyToAllListeners();

        this.controller.updateApplyToAllDropdown();
    }

    renderTextOptionsList(element: DesignerText, datalist: HTMLDataListElement): HTMLDivElement{
        let optionsList = document.createElement('div');
        optionsList.classList.add("text_select_options_list");
        for(let option of element.selectOptions){
            let optionItem = document.createElement('div');
            optionItem.dataset.optionValue = option;
            optionItem.innerHTML = "- " + option;

            //Remove option button
            let removeOptionButton = document.createElement('div');
            removeOptionButton.classList.add("text_select_option_remove_button");
            let removeIcon = document.createElement('img');
            removeIcon.classList.add("icon_small", "invert");
            removeIcon.src = this.controller.config.imagePath+'delete_white_24dp.svg';
            removeOptionButton.appendChild(removeIcon);

            optionItem.appendChild(removeOptionButton);

            optionsList.appendChild(optionItem);
        }

        return optionsList;
    }

    renderTextOptionsDatalist(element: DesignerText): HTMLDataListElement{
        let datalist = document.createElement('datalist');
        datalist.id = 'datalist_select_options_'+element.id;

        //First option is the default text of the element
        let defaultOption = document.createElement('option');
        defaultOption.value = element.defaultSelectOption;
        datalist.appendChild(defaultOption);

        for(let option of element.selectOptions){
            let optionEl = document.createElement('option');
            optionEl.value = option;
            datalist.appendChild(optionEl);
        }
        return datalist;
    }

    renderTextOptionsDropdown(element: DesignerText, text: HTMLInputElement ){
        let dropdownPredefinedContainer = document.createElement('div');
        dropdownPredefinedContainer.classList.add("text_predefined_dropdown_container");

        let options = [];
        options.push(element.defaultSelectOption);
        options = options.concat(element.selectOptions);

        if(element.selectOptions.length > 0){
            for(let option of options){
                let predefinedOption = document.createElement('div');
                predefinedOption.innerHTML = option;

                //Event listener to set predefined text
                predefinedOption.addEventListener('click', () => {
                    text.value = option;
                    //Trigger input event
                    let event = new Event('input', { bubbles: true, cancelable: true });
                    text.dispatchEvent(event);
                });

                dropdownPredefinedContainer.appendChild(predefinedOption);
            }

            let dropdownDiv: HTMLDivElement | null = null

            //Event listener to expand and collapse
            text.addEventListener('focus', () => {
                //dropdownPredefinedContainer.style.display = "flex";
                dropdownDiv = this.controller.designerDiv.appendChild(dropdownPredefinedContainer);
                let rect = text.getBoundingClientRect();
                dropdownDiv.style.position = "absolute";
                dropdownDiv.style.zIndex = "9999";
                dropdownDiv.style.left = rect.left + "px";
                dropdownDiv.style.top = (rect.bottom + 2) + window.scrollY + "px";
                dropdownDiv.style.width = rect.width + "px";
            });
            text.addEventListener('blur', () => {
                setTimeout( () => {
                    //dropdownPredefinedContainer.style.display = "none";
                    if(dropdownDiv){
                        dropdownDiv.remove();
                        dropdownDiv = null;
                    }
                }, 200);
            });
        }
    }
    
    //Tab for clipart and uploads
    renderImageTab(){
        if(this.tabsHTML == null){
            return false;
        }
        document.getElementById('config_tabs')!.innerHTML = this.tabsHTML.image;
        this.controller.setUIValues();

        

        let _this = this;
        let clipart_category = document.getElementById('clipart_category') as HTMLSelectElement;
        clipart_category.addEventListener('change', () => {
            this.API.requestClipart().then(
                (data:any) => {
                    _this.loadClipart( clipart_category.value, data );
                }
            );
        });

        this.API.requestClipart().then(
            (data:any) => {
                let clipartData = data;
                this.loadClipartCategories(clipartData);
                //Load first category
                let firstCategory = clipart_category.options[0].value;
                this.loadClipart(firstCategory, clipartData);
            }
        );
    
        let imageInput = document.getElementById('image_upload') as HTMLInputElement;
        imageInput?.addEventListener('change', function (evt) {
            let selectedFiles = imageInput.files;
            if(selectedFiles && selectedFiles.length > 0){
                _this.controller.uploadImage(selectedFiles[0]);
            }
        });
    }

    //Tab for clipart and uploads
    renderFullTab(){
        if(this.tabsHTML == null){
            return false;
        }
        let tab = document.getElementById('config_tabs');
        tab!.innerHTML = this.tabsHTML.full;
        this.controller.setUIValues();

        let text_placeholder = tab?.querySelector('.text_placeholder') as HTMLDivElement;
        text_placeholder.innerHTML = this.tabsHTML.full_text;

        if(this.controller.MCI){
            text_placeholder.innerHTML = this.tabsHTML.full_text_mci;
        }

        let uploadFullWidthInput = document.getElementById('upload_full_width') as HTMLInputElement;
        uploadFullWidthInput.max = (this.controller.config.maxWidthMM).toString();
        if(this.controller.imageFullWidth){
            uploadFullWidthInput.value = this.controller.imageFullWidth.toString();
        }else{
            uploadFullWidthInput.value = (this.controller.config.maxWidthMM).toString();
        }

        let _this = this;
        uploadFullWidthInput.addEventListener('change', () => {
            this.controller.imageFullWidth = uploadFullWidthInput.valueAsNumber;
        });
    
        
        let upload_full_input = document.getElementById('upload_full') as HTMLInputElement;
        upload_full_input.addEventListener('change', () => {
            let selectedFiles = upload_full_input.files;
            let width = uploadFullWidthInput.valueAsNumber;

            if(selectedFiles && selectedFiles.length > 0 && selectedFiles[0] != null && width){
                //Check if there are elements and ask for confirmation
                if(_this.controller.elements.length > 0){
                    let dialog = _this.controller.dialogInterface.addDialog("Bestehende Gestaltung überschreiben?", "Das Laden einer kompletten Gestaltung überschreibt die bestehende Gestaltung! Fortfahren?", "Ja", "Nein");

                    dialog.show().then( () => {
                        if(selectedFiles != null && selectedFiles[0] != null && width){
                            _this.controller.uploadImageFull( selectedFiles[0], width);
                        }
                    }, 
                    () => {
                        //Reset input
                        upload_full_input.value = '';
                        upload_full_input.files = null;
                        return;
                    } );
                }else{
                    _this.controller.uploadImageFull( selectedFiles[0], width);
                }
            }
        });

        upload_full_input.addEventListener('click', function(){
            this.value = '';
        });
    
        let upload_full_label = document.getElementById('upload_full_label') as HTMLLabelElement;

        let addDragClass = function() {
            upload_full_label.classList.add('is-dragover');
        }

        let removeDragClass = function() {
            upload_full_label.classList.remove('is-dragover');
        }

        //Visual Drag & Drop indication
        upload_full_label.addEventListener('dragenter', addDragClass);
        upload_full_label.addEventListener('dragover', addDragClass);

        upload_full_label.addEventListener('dragend', removeDragClass);
        upload_full_label.addEventListener('drop', removeDragClass);
        upload_full_label.addEventListener('dragexit', removeDragClass);
        upload_full_label.addEventListener('dragleave', removeDragClass);
    }
    
    //Show border tab
    renderBorderTab(){
        if(this.tabsHTML == null){
            return false;
        }
        let config_tabs = document.getElementById('config_tabs');
        config_tabs!.innerHTML = this.tabsHTML.border;
        this.controller.setUIValues();
    
        let _this = this;
        let border_strength = document.getElementById('border_strength') as HTMLInputElement;
        let border_padding = document.getElementById('border_padding') as HTMLInputElement;
    
        border_strength.addEventListener('change', () => {
            _this.setBorderWidth( border_strength.valueAsNumber );
            _this.controller.preScaleBorderWidth = this.controller.border.width / this.controller.scaling;
        });
    
        border_padding.addEventListener('change', () => {
            _this.setBorderPadding( border_padding.valueAsNumber );
            _this.controller.preScaleBorderPadding = this.controller.border.padding / this.controller.scaling;
        });

        
        let maxBorderSize = Math.min( _this.controller.config.maxHeightMM, _this.controller.config.maxWidthMM ) / 2;
        maxBorderSize -= 1.5; //Leave  space for content
        maxBorderSize = Math.floor(maxBorderSize * 4) / 4; //Round to nearest 0.25
        
        document.getElementById('border_strength_add')?.addEventListener("click", () => {
            border_strength.value = Math.min( maxBorderSize ,border_strength.valueAsNumber + 0.25).toFixed(2);
            _this.setBorderWidth( border_strength.valueAsNumber );
            _this.controller.preScaleBorderWidth = this.controller.border.width / this.controller.scaling;
        });
        document.getElementById('border_strength_remove')?.addEventListener("click", () => {
            border_strength.value = Math.max(0.25, border_strength.valueAsNumber - 0.25).toFixed(2);
            _this.setBorderWidth( border_strength.valueAsNumber );
            _this.controller.preScaleBorderWidth = this.controller.border.width / this.controller.scaling;
        });
    
        document.getElementById('border_padding_add')?.addEventListener("click", () => {
            border_padding.value = Math.min(maxBorderSize, border_padding.valueAsNumber + 0.25).toFixed(2);
            _this.setBorderPadding( border_padding.valueAsNumber );
            _this.controller.preScaleBorderPadding = this.controller.border.padding / this.controller.scaling;
        });
        document.getElementById('border_padding_remove')?.addEventListener("click", () => {
            border_padding.value = Math.max(0, border_padding.valueAsNumber - 0.25).toFixed(2);
            _this.setBorderPadding( border_padding.valueAsNumber );
            _this.controller.preScaleBorderPadding = this.controller.border.padding / this.controller.scaling;
        });
    
        let borderTypeButtons = document.getElementsByClassName("border_type");
        for(let button of borderTypeButtons){
            //Show active option
            let val = (button as HTMLElement).dataset.value;
            if(val == "single" && this.controller.border.active && this.controller.border.double == false){
                button.classList.add("list_button_active");
            }
            if(val == "double" && this.controller.border.active && this.controller.border.double == true){
                button.classList.add("list_button_active");
            }
            if(val == "none" && this.controller.border.active == false){
                button.classList.add("list_button_active");
            }
    
            button.addEventListener("click", () => {
                for(let button2 of borderTypeButtons){
                    button2.classList.remove("list_button_active");
                }
                if(val == "single"){
                    this.controller.border.active = true;
                    this.controller.border.double = false; 
                }
                if(val == "double"){
                    this.controller.border.active = true;
                    this.controller.border.double = true; 
                }
                if(val == "none"){
                    this.controller.border.active = false;
                }
                button.classList.add("list_button_active");
                this.controller.update();
            });
        }

        //LINES
        let line_width = document.getElementById('line_width') as HTMLInputElement;
        let line_length = document.getElementById('line_length') as HTMLInputElement;

        //LINE WIDTH
        line_width.addEventListener('change', () => {
            _this.setLineWidth( line_width.valueAsNumber );
        });

        document.getElementById('line_width_add')?.addEventListener("click", () => {
            line_width.value = Math.min(10, line_width.valueAsNumber + 0.25 ).toFixed(2);
            _this.setLineWidth( line_width.valueAsNumber );
        });
        document.getElementById('line_width_remove')?.addEventListener("click", () => {
            line_width.value = Math.max(0.25, line_width.valueAsNumber - 0.25).toFixed(2);
            _this.setLineWidth( line_width.valueAsNumber );
        });


        //LINE LENGTH
        line_length.addEventListener('change', () => {
            _this.setLineLength( line_length.valueAsNumber );
        });

        document.getElementById('line_length_add')?.addEventListener("click", () => {
            line_length.value = Math.min(100, line_length.valueAsNumber + 0.25).toFixed(2);
            _this.setLineLength( line_length.valueAsNumber );
        });
        document.getElementById('line_length_remove')?.addEventListener("click", () => {
            line_length.value = Math.max(1, line_length.valueAsNumber - 0.25).toFixed(2);
            _this.setLineLength( line_length.valueAsNumber );
        });

        //LINE ORIENTATION
        let orientationButtons = document.getElementsByClassName("line_orientation");
        for(let button of orientationButtons){
            //Show active option
            let val = (button as HTMLElement).dataset.value;
            if(val == "horizontal" && this.controller.lineSpawn.orientation == "horizontal"){
                button.classList.add("list_button_active");
            }
            if(val == "vertical" &&  this.controller.lineSpawn.orientation == "vertical"){
                button.classList.add("list_button_active");
            }
    
            button.addEventListener("click", () => {
                //Clear classes on value change
                for(let button2 of orientationButtons){
                    button2.classList.remove("list_button_active");
                }
                if(val == "horizontal"){
                    this.controller.lineSpawn.orientation = "horizontal";
                }
                if(val == "vertical"){
                    this.controller.lineSpawn.orientation = "vertical";
                }
                button.classList.add("list_button_active");
                this.controller.update();
            });
        }

        //LINE SPAWN
        document.getElementById('add_line_button')?.addEventListener("click", () => {
            let center = _this.controller.editAreaCenter();
            let x = center.x;
            let y = center.y;

            let w = _this.controller.lineSpawn.length * _this.controller.config.pixelToMM;
            let h = _this.controller.lineSpawn.width * _this.controller.config.pixelToMM;
            let orientation = _this.controller.lineSpawn.orientation;
            
            let rect = new DesignerRect(_this.controller, x, y, w, h, _this.controller.inkpadColor, orientation);
            rect.addElement(true);

            _this.controller.input.elementSelected = rect;
        });

        if(this.controller.MCI){
            let div = document.getElementById('border_color_select') as HTMLDivElement;
            if(div){
                this.generateBorderColors(div);
            }
        }else{
            document.getElementById('border_color_group')?.remove();
        }
    }

    //Show QR tab
    renderQRTab(){
        if(this.tabsHTML == null){
            return false;
        }
        let tab = document.getElementById('config_tabs');
        tab!.innerHTML = this.tabsHTML.qr;
        this.controller.setUIValues();

        let qr_select = document.getElementById('qr_gen_select') as HTMLButtonElement;
        let qr_vk_select = document.getElementById('qr_vk_select') as HTMLButtonElement;

        qr_select.addEventListener('click', () => {
            
            this.setQRSubtab("gen");
        });
        qr_vk_select.addEventListener('click', () => {
            
            this.setQRSubtab("vk");
        });

        this.setQRSubtab("gen");

        
    }

    setQRSubtab(subtab: string){
        if(this.tabsHTML == null){
            return false;
        }
        let qr_select = document.getElementById('qr_gen_select') as HTMLButtonElement;
        let qr_vk_select = document.getElementById('qr_vk_select') as HTMLButtonElement;

        let subtab_area = document.getElementsByClassName('sub_tab')[0] as HTMLDivElement;
        switch(subtab){
            case "gen":
                subtab_area.innerHTML = this.tabsHTML.qr_gen;
                qr_select.classList.add("active");
                qr_vk_select.classList.remove("active");
                this.renderQRGenTab();
                break;
            case "vk":
                subtab_area.innerHTML = this.tabsHTML.qr_vk;
                qr_vk_select.classList.add("active");
                qr_select.classList.remove("active");
                this.renderQRVKTab();
                break;
        }
        this.controller.bindTooltips();
    }

    renderQRGenTab(){
        //Submit
        let form = document.getElementById('qr_gen_form') as HTMLDivElement;

        let textInput = form.querySelector('#qr_input_text') as HTMLInputElement;
        let submit = form.querySelector('#qr_submit') as HTMLButtonElement;
        submit.addEventListener('click', () => {
            let text = textInput.value;
            if(text == null || text.length < 1){
                this.controller.showMessage("error", "Bitte Text für QR-Code eingeben");
                return;
            }

            this.API.GenerateQRCode( text, this.config.dataset.tid ).then(
                (data:any) => {
                    if(data){
                        if(data.qrcode){
                            //Create QR Code
                            
                            let size = 30 * this.config.pixelToMM;
                            let area = this.controller.editAreaSize();
                            let pad = this.config.pixelToMM * 2;

                            size = Math.min(area.w - pad, area.h - pad, size);
                            size = Math.max(size, this.config.QRMinHeight * this.config.pixelToMM, this.config.QRMinWidth * this.config.pixelToMM);

                            let img = new DesignerQRCode(this.controller, 0, 0, data.qrcode, true, "#000000", size, size);
                            img.text = data.text;
                            img.x = area.minX + area.w / 2;
                            img.y = area.minY + area.h / 2;
                            img.addElement();

                            //If space to fit next to it, move it
                            let bounds = this.controller.calcBounds();
                            if( area.w - bounds.w > img.w ){
                                let move = bounds.w / 2 + img.w / 2;

                                //Make space for QR-Code
                                this.controller.moveDesign(img.w / 2, 0, true, true);

                                img.moveRelative( -move, 0, false, true, false, true);
                            }

                        
                            this.controller.showMessage("success", `QR-Code "`+data.text+`" generiert:
                                <br>
                                <div>
                                    <img src="`+data.qrcode+`" alt="QR-Code" style="max-height:256px;"/>
                                </div>`, false);
                        }else{
                            this.controller.showMessage("error", "Fehler beim Erstellen des QR-Code");
                        }
                    }
                
                }
            );
        });
    }

    renderQRVKTab(){
        let copyButtonHTML = '<button id="copy_vk_edit_link_button" class="copy_button" title="In Zwischenablage kopieren"> <img src="'+this.config.imagePath+'copy_white_24dp.svg" class="icon invert"/> </button>';

        //Submit
        let form = document.getElementById('qr_vk_form') as HTMLDivElement;
        let submit = form.querySelector('#qr_vk_submit') as HTMLButtonElement;
        submit.addEventListener('click', () => {
            let bonusParams: {[key: string]: string} = {
                tid: this.config.dataset.tid
            };

            //Add all input values to bonusParams
            let vkElements = form.querySelectorAll('input, select, textarea');
            for(let element of vkElements){
                let input = element as HTMLInputElement;
                bonusParams[input.name] = input.value;
            }

            this.API.GenerateVK( bonusParams ).then(
                (data:any) => {
                    if(data){
                        if(data.savedResult){
                            this.controller.vkdata.url = data.link;
                            this.controller.vkdata.urlEdit = data.edit;

                            this.controller.setUIValues();

                            if(data.qrcode){
                                //Create QR Code
                                let exist = this.controller.checkQRCodeExists(data.link);
                                if(exist == null){
                                    let size = 30 * this.config.pixelToMM;
                                    let area = this.controller.editAreaSize();
                                    let pad = this.config.pixelToMM * 2;

                                    size = Math.min(area.w - pad, area.h - pad, size);
                                    size = Math.max(size, this.config.QRMinHeight * this.config.pixelToMM, this.config.QRMinWidth * this.config.pixelToMM);

                                    let img = new DesignerQRCode(this.controller, 0, 0, data.qrcode, true, "#000000", size, size);
                                    img.text = data.link;
                                    img.center();
                                    img.addElement();
                                }else{
                                    exist.setImage(data.qrcode, true);
                                }
                            }

                            if(data.updated == false){
                                
                                this.controller.showMessage("success", `Digitale Visitenkarte erfolgreich erstellt: 
                                    <br>
                                    <br> 
                                    <div> 
                                        - VK-Code: `+data.token + `<br> 
                                        - Link zur Visitenkarte: <a href="`+data.link+`" target='_blank'> `+data.link+` </a> <br>
                                        - Link zum späteren Bearbeiten: `+copyButtonHTML+` <a href="`+data.edit+`" target='_blank'>  `+data.edit+` </a> 
                                    </div>`, false);

                                let copyButton = document.getElementById('copy_vk_edit_link_button');
                                if(copyButton){
                                    copyButton.addEventListener('click', () => {
                                        navigator.clipboard.writeText(data.edit);
                                    });
                                }
                            }else{
                                this.controller.showMessage("success", `Digitale Visitenkarte aktualisiert:
                                    <br>
                                    <br> 
                                    <div> 
                                        - VK-Code: `+data.token + `<br> 
                                        - Link zur Visitenkarte: <a href="`+data.link+`" target='_blank'> `+data.link+` </a> <br>
                                        - Link zum späteren Bearbeiten: `+copyButtonHTML+` <a href="`+data.edit+`" target='_blank'>  `+data.edit+` </a>
                                    </div>`, false);
                            }
                        }
                        if(!data.savedResult){
                            this.controller.showMessage("error", "Fehler beim Erstellen der Visitenkarte: VK-Code:"+data.token);
                        }
                    }
                }
            );
        });

        //Image upload
        let vk_image_input = document.getElementById('vk_image') as HTMLInputElement;
        vk_image_input?.addEventListener('change', (evt) => {
            let selectedFiles = vk_image_input.files;
            if(selectedFiles && selectedFiles.length > 0){
                this.controller.uploadImageVK(selectedFiles[0]);
            }
        });

        let vkElements = form.querySelectorAll('input, select, textarea');

        //Load saved input values
        for(let element of vkElements){
            let input = element as HTMLInputElement;
            if(input.name in this.controller.vkdata){
                let val = this.controller.vkdata[input.name];
                if(val){
                    input.value = val;
                }
            }
        }

        this.controller.setUIValues();

        //Save input values
        for(let element of vkElements){
            let input = element as HTMLInputElement;
            input.addEventListener('change', (evt) => {
                let el = evt.target as HTMLInputElement;
                this.controller.vkdata[el.name] = el.value;
            });
        }

        //Copy edit link to clipboard
        let vk_link_edit_copy_static = document.getElementById('copy_vk_edit_link_button_static') as HTMLAnchorElement;
        if(vk_link_edit_copy_static){
            vk_link_edit_copy_static.addEventListener('click', () => {
                if(this.controller.vkdata.urlEdit !== null){
                    navigator.clipboard.writeText(this.controller.vkdata.urlEdit);
                }
            });
        }
    }

    generateBorderColors(div: HTMLDivElement){
        for(let key in this.controller.MCIColors){
            let color:ColorObject = this.controller.MCIColors[key];

            let colorButton = document.createElement('div');
            colorButton.classList.add('mci_color_button', 'border_color_button');
            colorButton.style.backgroundColor = color.hex;
            colorButton.dataset.color = color.hex;
            colorButton.dataset.colorName = color.name;

            colorButton.addEventListener('click', (evt) => {
                if(!evt.target){
                    return;
                }
                let target = (evt.target as HTMLDivElement);
                let buttonColor = target.dataset.color;
                if(buttonColor){
                    this.setBorderColor(buttonColor);

                    //Set active buttons and highlight
                    let otherButtons = this.controller.designerDiv.querySelectorAll('.mci_color_button.border_color_button');
                    for(let otherButton of otherButtons){
                        otherButton.classList.remove('active');
                    }
                    colorButton.classList.add('active');
                    this.controller.update();
                }
            });

            if(this.controller.border.color == color.hex){
                colorButton.classList.add('active');
            }

            div.appendChild(colorButton);
        }
    }

    setBorderColor(color:string){
        this.controller.border.color = color;
        this.controller.update();
    }

    //Set width of newly spawned lines
    setLineWidth(value: number){
        this.controller.lineSpawn.width = value;
        this.controller.update();
    }

    //Set length of newly spawned lines
    setLineLength(value: number){
        this.controller.lineSpawn.length = value;
        this.controller.update();
    }

    //Load clipart categories and create dropdown
    loadClipartCategories(clipartData: any = null){
        if(clipartData == null){
            return;
        }
        let clipart_category = document.getElementById('clipart_category');
        for(let key in clipartData){
            //Category List
            if(key == "kategorien"){
                let categories: string[] = clipartData[key]; 
                for(let category of categories){
                    let option = document.createElement("option");
                    option.value = category;
                    option.innerHTML = category;
                    clipart_category?.appendChild(option);
                }
                break;
            }
        }
    }

    //Load Clipart collection
    loadClipart(filterCategory:string|null = null, clipartData: any = null){
        if(clipartData == null){
            return;
        }
        let clipart_list = document.getElementById('clipart_list');

        if(!clipart_list){
            return;
        }

        for(let key in clipartData){
            //Ignore category list
            if(key == "kategorien"){
                continue;
            }
            //Continue if category is not the one currently selected
            if(filterCategory != null && filterCategory != key){
                continue;
            }
            
            clipart_list.innerHTML = "";
            //Create clipart elements
            let category = clipartData[key]; 
            for(let keyClipart in category){
                let clipart:Clipart = category[keyClipart];
                let clipartDiv = document.createElement('div');
                let url = this.config.clipartPath+clipart.path;
                clipartDiv.style.backgroundImage = 'url('+url+')';
                clipartDiv.classList.add("clipart");
                clipartDiv.dataset.url = url;
                clipart_list.appendChild(clipartDiv);

                let _this = this;
                clipartDiv.addEventListener("click", function(){
                    

                    let w = Number.parseFloat(clipart.width);
                    let h = Number.parseFloat(clipart.height);

                    w /= _this.config.clipartScaling;
                    h /= _this.config.clipartScaling;

                    w = Math.max(_this.controller.config.imageSpawnMinWidth * _this.controller.config.pixelToMM, w);
                    h = Math.max(_this.controller.config.imageSpawnMinHeight * _this.controller.config.pixelToMM, h);

                    let area = _this.controller.editAreaSize();
                    //Get scale of what can fit
                    let scaleW = (area.w + 4) / w;
                    let scaleH = (area.h + 4) / h;
                    let scale = Math.min(scaleW, scaleH);

                    //Scale down to fit
                    if(scale < 1){
                        w *= scale;
                        h *= scale;
                    }
                    

                    let center = _this.controller.editAreaCenter();

                    

                    let image = new DesignerImage(_this.controller, center.x, center.y, url, true, "#000000", w, h);
                    //image.clampSize();
                    //image.center();
                    image.addElement();
                });
            }
            
            //If no category selected, stop at first
            if(filterCategory == null){
                break;
            }
        }
    }

    //Display user patterns in a grid list
    renderUserPatterns(artikel_nr: number | string, userCode: string, useCache = true){
        this.controller.API.requestUserPatterns(artikel_nr, userCode, useCache).then(
            (data:any) => {
                let user_patterns = document.getElementById('userpattern_patterns_list');
                if(!user_patterns){
                    console.error("Couldn't find user pattern list element!", "userpattern_patterns_list");
                    return;
                }

                //Clear list
                user_patterns.innerHTML = "";

                //Build user pattern list
                for(let key in data){
                    let pattern = data[key]; 
                    let patternDiv = document.createElement('div');
                    let patternDivTitle = document.createElement('div');
                    patternDivTitle.classList.add("pattern_user_title");
                    let patternDivImageBox = document.createElement('div');
                    patternDiv.classList.add("pattern_box");
                    patternDiv.dataset.patternName = pattern.name;
                    patternDiv.dataset.patternID = key;
                    patternDiv.dataset.ident = pattern.ident;
    
                    let _this = this;
                    patternDiv.addEventListener("click", function(){
                        let patternID = this.dataset.patternID;
                        if(!patternID){
                            console.error("Pattern has no ID! Can't load.");
                            return;
                        }
                        let id = Number.parseInt(patternID);
                        _this.controller.patternController.loadUserPattern(artikel_nr, userCode, id, false, true, false);
                    });

                    let patternDivName = document.createElement('div');
                    patternDivName.innerText = "Muster "+pattern.name;

                    //Delete element
                    let patternDivDelete = document.createElement('div');
                    patternDivDelete.innerText = "X";
                    patternDivDelete.title = "Delete";
                    patternDivDelete.classList.add("pattern_user_title_delete");

                    patternDivDelete.addEventListener("click", function(e){
                        e.stopPropagation();
                        let pattern_box = this.parentElement?.parentElement;
                        if(!pattern_box){
                            return;
                        }

                        let dialog = _this.controller.dialogInterface.addDialog("Muster " + pattern_box.dataset.patternName + " wirklich löschen?", "", "Ja", "Nein");

                        dialog.show(pattern_box).then( (pattern_box) => {
                            let PatternIdent = pattern_box.dataset.ident;
                            if(!PatternIdent){
                                console.error("Pattern has no ident! Can't delete.");
                                return;
                            }
                            let ident = Number.parseInt(PatternIdent);
                            _this.deleteUserPattern(artikel_nr, userCode, ident);
                            pattern_box.remove();
                        });
                    });

                    patternDivTitle.appendChild(patternDivName);

                    if(this.controller.config.userPattern.delete == true){
                        patternDivTitle.appendChild(patternDivDelete);
                    }
    
                    patternDivImageBox.classList.add("pattern_box_image");
    
                    let img = document.createElement('div');
                    img.style.backgroundImage = "url("+pattern.jpg+")";
                    
    
                    patternDivImageBox.appendChild(img);
    
                    patternDiv.appendChild(patternDivTitle);
                    patternDiv.appendChild(patternDivImageBox);
                    user_patterns.appendChild(patternDiv);
                }
            }
        )
    }

    //Generate neccesary data and save via API
    saveUserPattern(userCode: string, name: string): boolean{
        let designData = this.controller.generateDesignData( this.controller.config.dataset.artikel, this.config.typ);
        if(!designData){
            console.error('Couldnt generate design data');
            return false;
        }

        let imageData = this.controller.getImageData(RenderMode.Preview);
        if(!imageData){
            console.error('Couldnt generate image data');
            return false;
        }

        this.controller.API.uploadUserPattern(this.config.dataset.artikel, userCode , this.config.dataset.tid, name, designData, imageData, this.config.pixelToMM, this.controller.MCI).then(
            (data:any) => {
                if(!data){
                    console.error("Empty Server Response");
                    return false;
                }
                if(data.data){
                    let message = data.message;

                    this.controller.showMessage("success", message);

                    //Update pattern list
                    //Refresh cache
                    this.controller.API.patternCache.user = null;
                    this.renderUserPatterns(this.config.dataset.artikel, userCode, false);

                    return true;
                }else{
                    console.log("Couldn't save pattern");
                    return false;
                }
            }
        ,(error) => {
            console.error(error);
            return false;
        });
        return false;
    }

    //Delete "design patterns"(Gestaltungsmuster) via API
    deleteUserPattern(artikel_nr: number | string, userCode: string, ident: number){
        this.controller.API.deleteUserPattern(artikel_nr, userCode, ident).then(
            (data:any) => {
                let message = data.message;
                if(data.success){
                    this.controller.showMessage("success", message);

                    //Update pattern list
                    //Refresh cache
                    this.controller.API.patternCache.user = null;
                    this.renderUserPatterns(this.config.dataset.artikel, userCode, false);

                    //_this.patternCache.user = null;
                    
                    return true;
                }
                return false;
            }
        );
    }

    //Set border width and update canvas
    setBorderWidth(value: number){
        let val = Utility.clamp(value, this.config.borderMinWidth, this.config.borderMaxWidth);
        val = Utility.roundDigit(val);
        this.controller.border.width = val;
        this.controller.update();
    }

    //Set border padding and update canvas
    setBorderPadding(value: number){
        this.controller.border.padding = value;
        this.controller.update();
    }

    //Mark active tab with special background
    showActiveTab(){
        let icons = document.getElementsByClassName("toolbar_icon");
        for(let icon of icons){
            icon.classList.remove("active");
        }
        switch(this.activeTab){
            case 'text':
                this.renderTextTab();
                document.getElementById("toolbar_text")?.classList.add("active");
            break;
            case 'pattern': 
                this.renderPatternTab();
                document.getElementById("toolbar_pattern")?.classList.add("active");
            break;
            case 'userpattern': 
                this.renderUserPatternTab();
                document.getElementById("toolbar_userpattern")?.classList.add("active");
            break;
            case 'image': 
                this.renderImageTab();
                document.getElementById("toolbar_image")?.classList.add("active");
            break;
            case 'border':
                this.renderBorderTab();
                document.getElementById("toolbar_border")?.classList.add("active");
            break;
            case 'full':
                this.renderFullTab();
                document.getElementById("toolbar_full")?.classList.add("active");
            break;
            case 'qr':
                this.renderQRTab();
                document.getElementById("toolbar_qr")?.classList.add("active");
            break;
        }
        this.controller.bindTooltips();
    }

    //Highlight clicked text element in the text list
    highlightText(id: number){
        if(this.activeTab != "text"){
            return;
        }
        let list = document.getElementById("item_list");
        let children = list?.childNodes as NodeListOf<HTMLDivElement>;
        if(!children){
            return;
        }
        this.unhighlightText();
        for(let child of children){
            if(child.dataset.id == id.toString() ){
                child.classList.add("designer_highlight");
                /*
                let input = child.getElementsByClassName("text_input")[0] as HTMLInputElement;
                if(input){
                    //Fix for focus not working
                    window.setTimeout(function () { 
                        input.focus();
                    }, 0); 
                    
                }*/
            }
        }
    }

    //Remove highlighting from every row in the text list
    unhighlightText(){
        if(this.activeTab != "text"){
            return;
        }
        let list = document.getElementById("item_list");
        let children = list?.childNodes as NodeListOf<HTMLDivElement>;
        if(!children){
            return;
        }
        let selectedElement = this.controller.input.elementSelected;
        for(let child of children){
            if(selectedElement && child.dataset.id == selectedElement.id.toString() ){
                continue;
            }
            child.classList.remove("designer_highlight");
        }
    }

    addApplyToAllListeners(){
        document.getElementById('apply_to_all')?.addEventListener('change', (evt) => {
            this.controller.updateApplyToAllDropdown();
        });
        
        
        document.getElementById('apply_to_all_button')?.addEventListener('click', (evt) => {
            let select = document.getElementById('apply_to_all') as HTMLSelectElement;
            if(!select){
                return;
            }
            let selectedOption = select.value;
            let input;
            switch(selectedOption){
                case 'fontsize':
                    input = document.querySelector(".textsize_select.designer_apply_to_all_input") as HTMLSelectElement;
                    if(input){
                        let value = Number.parseFloat(input.value);
                        for(let element of this.controller.elements){
                            if(! (element instanceof DesignerText) ){
                                continue;
                            }
                            if( element instanceof DesignerDate){
                                continue;
                            }
                            element.setSize(value, true, true, true, false);
                        }
                        for(let element of this.controller.elements){
                            if(! (element instanceof DesignerText) ){
                                continue;
                            }
                            if( element instanceof DesignerDate){
                                continue;
                            }
                            element.moveRelative(0,0);
                        }
                        this.controller.update(true, true, true);
                    }
                break;
                case 'font':
                    input = document.querySelector(".font_select.designer_apply_to_all_input") as HTMLSelectElement;
                    if(input){
                        let value = input.value;
                        for(let element of this.controller.elements){
                            if(! (element instanceof DesignerText) ){
                                continue;
                            }
                            if( element instanceof DesignerDate){
                                continue;
                            }
                            element.setFont(value, true, true, false);
                        }
                        this.controller.update(true, true, true);
                    }
                break;
                case 'align':
                    input = document.querySelector(".align_select.designer_apply_to_all_input") as HTMLSelectElement;
                    if(input){
                        let value = input.value as Alignment;
                        if(input.value == "none"){
                            value = null;
                        }
                        
                        for(let element of this.controller.elements){
                            if(! (element instanceof DesignerText) ){
                                continue;
                            }
                            if( element instanceof DesignerDate){
                                continue;
                            }
                            element.setAlignment(value, false);
                            element.applyAlignment(true);
                        }

                        //Second pass for changed bounds
                        for(let element of this.controller.elements){
                            if(! (element instanceof DesignerText) ){
                                continue;
                            }
                            if( element instanceof DesignerDate){
                                continue;
                            }
                            element.applyAlignment(true);
                        }
                        this.controller.update(true, true, true);
                    }
                break;
                case 'text_special':
                    input = document.querySelector(".text_special_select.designer_apply_to_all_input") as HTMLSelectElement;
                    if(input){
                        let value = input.value;
                        for(let element of this.controller.elements){
                            if(! (element instanceof DesignerText) ){
                                continue;
                            }
                            if( element instanceof DesignerDate){
                                continue;
                            }
                            if(value == "none"){
                                element.setBold(false);
                                element.setItalic(false);
                                element.setUnderline(false);
                                element.setDimensions(true);
                            }
                            if(value == "bold"){
                                element.setBold(true);
                                element.setDimensions(true);
                            }
                            if(value == "italic"){
                                element.setItalic(true);
                                element.setDimensions(true);
                            }
                            if(value == "underline"){
                                element.setUnderline(true, false);
                                element.setDimensions(true);
                            }
                        }
                        this.controller.update(true, true, true);
                    }
                break;
            }
        });
    }

    generateFontSizeDropdown(stepSize: number, activeSize: number = 0){
        let textsize = document.createElement("select");
        textsize.classList.add('textsize_select');
        for(let size:number = this.config.fontMinSize;size <= this.config.fontMaxSize;size += stepSize){
            let sizeSteps = 1/stepSize;
            let sizeRounded = Math.round(size * sizeSteps)/sizeSteps;

            let elementSizeRounded = Math.round(activeSize * sizeSteps)/sizeSteps;

            var option = document.createElement("option");
            let sizeStr = sizeRounded.toString();
            option.value = sizeStr;
            if(sizeStr.includes(".")){
                option.text = Math.floor(sizeRounded).toString()+"½pt";
            }else{
                option.text = sizeStr+"pt";
            }
            option.text = sizeStr+"pt";
            
            if(elementSizeRounded == sizeRounded){
                option.selected = true;
            }
            textsize.appendChild(option);
            if(size >= 20){
                stepSize = 1;
            }
        }

        return textsize;
    }

    generateFontDropdown(activeFont: string = ""){
        let fontDropdown = document.createElement("select");
        fontDropdown.classList.add('font_select');

        for(let font of this.controller.fonts){
            var option = document.createElement("option");
            option.value = font.name;
            let img = document.createElement("img");
            img.fetchPriority = "low";
            img.loading = "lazy";
            img.src = 'https://www.stempelcloud24.com/fonts/' + font.name.toLowerCase() + '_n.png';
            img.alt = font.name;
            option.appendChild(img);
            //option.text = fontname;
            //option.style.fontFamily = fontname;
            if(activeFont == font.name){
                option.selected = true;
            }
            fontDropdown.appendChild(option);
        }
        return fontDropdown;
    }

    generateAlignDropdown(activeAlignment: Alignment){
        let align = document.createElement("select");
        align.classList.add('align_select');

        let alignments:Array<Alignment|"none"> = new Array("centerH", "left", "right", "none");
        let alignmentsName:string[] = new Array("Mittig", "Links", "Rechts", "Keine");

        for(let index in alignments){
            let alignment = alignments[index];
            if(!alignment){
                continue;
            }
            var option = document.createElement("option");
            option.value = alignment;
            option.text = alignmentsName[index];
            if(activeAlignment == alignment){
                option.selected = true;
            }
            align.appendChild(option);
        }
        return align;
    }
    generateSpecialDropdown(activeSpecial: TextSpecials){
        let align = document.createElement("select");
        align.classList.add('text_special_select');

        let specialTypes:Array<TextSpecials|"none"> = new Array("bold", "italic", "underline", "none");
        let specialNames:string[] = new Array("Fett", "Kursiv", "Unterstrichen", "Keine");

        for(let index in specialTypes){
            let special = specialTypes[index];
            if(!specialTypes){
                continue;
            }
            var option = document.createElement("option");
            option.value = special;
            option.text = specialNames[index];
            if(activeSpecial == special){
                option.selected = true;
            }
            align.appendChild(option);
        }
        return align;
    }
}

export {TabInterface};